import { render, staticRenderFns } from "./EditAnalisisPenyelia.vue?vue&type=template&id=b1a121cc&scoped=true&"
import script from "./EditAnalisisPenyelia.vue?vue&type=script&lang=js&"
export * from "./EditAnalisisPenyelia.vue?vue&type=script&lang=js&"
import style0 from "./EditAnalisisPenyelia.vue?vue&type=style&index=0&id=b1a121cc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1a121cc",
  null
  
)

export default component.exports